import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VENDOR_AUTH_SERVICE } from '../auth/auth.service';
import { PingOneIdentityService } from './ping-one-identity.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: VENDOR_AUTH_SERVICE,
      useClass: PingOneIdentityService
    }
  ]
})
export class AwsCognitoModule {}
